import React from 'react';
import {SlotsPlaceholder} from '@wix/widget-plugins-ooi';
import {SlotIds} from '../../constants';

export class ReviewsSlot extends React.Component {
  public render() {
    return <SlotsPlaceholder slotId={SlotIds.ProductPageBottomSlot} />;
  }
}
